module.exports = __webpack_public_path__ + "static/media/company-w.5078fe4f.svg";